export default theme => ({
  phoneBox: {
    position: "absolute",
    bottom: 75,
    height: 150,
    width: 340,
    background: theme.palette.common.white,
    display: "flex",
    flexDirection: "column",
    borderRadius: "60px 15px 15px 15px",
    right: 0,
    [theme.breakpoints.down("xs")]: {
      width: 300,
    },
    [theme.breakpoints.down(376)]: {
      right: -15,
    },
    [theme.breakpoints.down(321)]: {
      right: -40,
    },
  },

  boxBody: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },

  ambulance: {
    marginRight: 20
  },

  icon: {
    fontSize: theme.typography.pxToRem(65),
    color: theme.palette.grey.eccoGrey
  },

  text: {
    fontSize: theme.typography.pxToRem(14),
    fontWeight: "bold",
    color: theme.palette.grey.eccoGrey,
    lineHeight: "17px",
    marginLeft: theme.spacing(["5", 2])
  },

  boxFooter: {
    padding: "5px 0",
    color: theme.palette.common.white,
    backgroundColor: theme.palette.grey.eccoGrey,
    fontSize: theme.typography.pxToRem(14),
    textAlign: "center",
    fontWeight: theme.typography.fontWeightMedium,
    position: "relative",
    borderRadius: "0 0 15px 15px",

    "& svg": {
      color: theme.palette.common.white,
      position: "absolute",
      left: 30
    },

    "& $text": {
      color: theme.palette.common.white
    }
  }
});
